

import styled from "styled-components";

export const Container = styled.div`
  background-color: var(--chat-background);
  width: 100%;
  height: 100%;

  @media (max-width: 768px) {
    height: 50vh;
    padding-bottom: 15vh;
  }

  .librasButton {
    font-size: 0.875em;
    border-radius: 2px;
    background-color: var(--dark-blue);
    color: white;
    border: 1px solid white;
    transition: filter 0.2s;

    #sign_language {
      font-size: 1em;
    }
    &:hover {
      filter: brightness(0.9);
    }

    @media (max-width: 685px) {
      font-size: 0.75em;
      gap: 5px;

      img {
        width: 20px;
        height: 20px;
      }
    }
  }

  @media (max-width: 1020px) {
    font-size: 0.875em;
    width: 100%;
    gap: 10px;

    .librasButton {
      width: 30%;
    }
  }
`;


export const Content = styled.div`
  height: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  padding: 0 10rem;
  margin: 0 auto;

  @media (max-width: 1500px) {
    padding: 0 2rem;
  }



  .ScenarioSearch {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 3rem;
    padding: 2.5rem 3rem;

    form {
      width: 100%;
    }
  }

  .SearchForm {
    cursor: pointer;
    background-color: var(--white);
    color: var(--primary-blue);
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;

    @media (min-width: 769px) {
      width: 50%;
    }
    span {
      width: 4rem;
      text-align: center;
    }
    .input {
      width: 100%;
      height: 2.5em;
      font-size: 18px;
      background-color: var(--white);
      border: 1px solid var(--white);
      color: var(--dark-blue);
      font-weight: 400;
      line-height: 50px;
      padding-left: 0.5em;
    }
  }

  .menuOption {
    width: 100%;
    padding-bottom: 0.5rem;
  }

  /* width */
  ::-webkit-scrollbar {
    width: 0.375rem;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0.313rem grey;
    border-radius: 0.625rem;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--scrollbar);
    border-radius: 0.625rem;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: var(--gray);
  }

  .headerContainerMessageAvatar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-radius: 0.5rem;
    color: white;
    border-radius: 0.625rem 0.625rem 0.625rem 0px;
    margin-bottom: 1.125rem;

    .sizeIcon {
      font-size: 1.5em;
      font-weight: 400;
    }
  }

  .messageAvatar {
    font-size: 0.875em;
    font-weight: 400;
    font-family: "Roboto", sans-serif;
    color: white;
  }

  .checkContainer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 4%;
  }

  .containerMenu {
    display: flex;
    flex-direction: column;
    gap: 0.313rem;
    background-color: var(--chat-background);
    margin-bottom: 0.313rem;
    height: auto;
    padding: 2%;
    border-radius: 0.625rem;
    box-shadow: 0.375rem 0.375rem 0.5rem -0.063rem rgba(0, 0, 0, 0.17);
    -webkit-box-shadow: 0.375rem 0.375rem 0.5rem -0.063rem rgba(0, 0, 0, 0.17);
    -moz-box-shadow: 0.375rem 0.375rem 0.5rem -0.063rem rgba(0, 0, 0, 0.17);
  }

  .headerContainerMenu {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0.625rem;
    margin-left: 0.6rem;
  }

  #menu {
    font-size: 1em;
    color: var(--white);
  }

  .subtitle {
    color: var(--clear-gray);
    font-size: 0.875em;
    margin-left: 0.6rem;
    margin-bottom: 0.2rem;
  }

  .menuLibras {
    margin: auto;
    width: 100%;
    display: flex;
    justify-content: center;
    
    @media (max-width: 768px){
      width: 100%;
    }
    
    gap: 0.625rem;
    padding: 0.23rem 3rem;

    button {
      justify-content: center;
      height: 3rem;
      font-size: 0.875em;
    }
  }

  .chosenOptionContainer {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width: 50%;
  }

  .checkIcon {
    color: #fff;
  }
`;  

export const ChatContainer = styled.div`
  margin-bottom: 0.8rem;
  margin-top: 0.438rem;
  border-radius: 1.25rem 1.25rem 1.25rem 0rem;
  background-color: var(--dark-blue);
  padding: 2% 2% 3% 3%;
`;
